<template>
  <div class="dataTable__row">
    <template v-for="(item, index) in row" :key="index">
      <CellDataTableComponent v-if="item.type" :item="item" :columns="columns" @emitRowAction="emitRowAction" />
    </template>
    <template v-if="actions && actions.length">
      <ActionCellDataTableComponent :actions="actions" :row="row" @clickAction="clickAction" />
    </template>
  </div>
</template>

<script>
import { dataTableManager } from "@/services/data-table/data-table-manager";
import ActionCellDataTableComponent from "@/components/data-table/cell/ActionCellDataTableComponent.vue";
import CellDataTableComponent from "@/components/data-table/cell/CellDataTableComponent.vue";

export default {
  name: "RowDataTableComponent",
  components: { CellDataTableComponent, ActionCellDataTableComponent },
  props: {
    row: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["emitRowAction", "clickAction"],
  methods: {
    emitRowAction(payload) {
      this.$emit("emitRowAction", { ...payload, id: dataTableManager.findId(this.row) });
    },

    clickAction(payload) {
      this.$emit("clickAction", payload);
    },
  },
};
</script>

<style lang="scss" scoped></style>
